export const fetchAllSuppliersQueryKey = () => ['suppliers'];
export const getSupplierQueryKey = (
  supplierId: number | string | undefined,
) => ['supplier', supplierId || 0];

export const getSupplierProductQueryKey = (
  supplierId: number | string | undefined,
  productId: number,
) => ['supplier', supplierId, 'product', productId || 0];
